import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import SplitRows from '../../components/general/SplitRow.js';
import OptionColumn from '../../components/general/OptionColumn.js';
import Notification from '../../components/Notification.js';
import Helmet from 'react-helmet';
import Switch from 'rc-switch';
import ColorPicker from "../../components/builder/ColorPicker";
import {setSetting} from '../../actions/General.js';

class SettingsDiscount extends React.Component {
    constructor(props) {
        super(props);

        this.saveStatus = this.saveStatus.bind(this);

    }

    handleTranslationSubmit(values) {
        this.setState({
            isSavingTranslation:true
        });

        axios.put('/settings',values).then(res => {
            this.setState({
                isSavingTranslation:false
            });

            for(let i in values) {
                this.props.setSetting(i,values[i]);
            }


            Notification.success('Success!');
        }).catch(err => {
            this.setState({
                isSavingTranslation:false
            });
        });
    }

    saveStatus() {

        this.handleTranslationSubmit({
            SAVE_DISCOUNT_ACTIVATED:this.props.general.settings.SAVE_DISCOUNT_ACTIVATED,
            SAVE_DISCOUNT_BG_COLOR:this.props.general.settings.SAVE_DISCOUNT_BG_COLOR,
            SAVE_DISCOUNT_TEXT:this.props.general.settings.SAVE_DISCOUNT_TEXT,
        })
    }

    componentWillMount() {

    }

    render() {

        return (
            <div className="full-height">
                <Helmet title="Discount | Crall.io" />
                <div className="page-header">
                    <span className="page-title"><i className="icon wb-tag"></i> Discount</span>
                </div>

                <div className="page-content">

                    <OptionColumn title="Reminder" description="Show a popup discount reminder in right bottom corner">
                        <div className="form-group col-sm-12">
                            <div className="col-sm-6">
                                <h5>Status</h5>
                                <div className="col-sm-12 text-center">
                                    Off &nbsp;&nbsp;
                                    <Switch onChange={(val) => { if(val == 'true' || val === true) {val='true';}else{val='false';}  this.props.setSetting('SAVE_DISCOUNT_ACTIVATED',val) } }
                                            checked={(this.props.general.settings.SAVE_DISCOUNT_ACTIVATED == 'true' || this.props.general.settings.SAVE_DISCOUNT_ACTIVATED === true  ? true:false)}
                                            checkedChildren={<i className="icon fa-check"></i>}
                                            unCheckedChildren={<i className="icon fa-close"></i>}
                                    /> &nbsp;On
                                </div>
                            </div>

                            <div className="form-group col-sm-6">
                                <h5>Background color</h5>
                                <ColorPicker id='SAVE_DISCOUNT_BG_COLOR' color={this.props.general.settings.SAVE_DISCOUNT_BG_COLOR} handleColorChange={(val,v) => { this.props.setSetting('SAVE_DISCOUNT_BG_COLOR',v) }} />

                                <br/><br/>

                                <h5>Additional text</h5>
                                <input type="text" id='SAVE_DISCOUNT_TEXT' className="form-control" value={this.props.general.settings.SAVE_DISCOUNT_TEXT} onChange={(e) => this.props.setSetting('SAVE_DISCOUNT_TEXT',e.target.value)} />

                            </div>

                        </div>

                        <div className="col-sm-12 m-t-20">
                            <button type="button" onClick={this.saveStatus} className="btn btn-dark btn-block">Save</button>
                        </div>
                    </OptionColumn>

                    <SplitRows />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({setSetting},dispatch)
}


SettingsDiscount = connect(mapStateToProps,mapDispatchToProps)(SettingsDiscount);
export default SettingsDiscount;



// WEBPACK FOOTER //
// ./containers/settings/SettingsDiscount.js